import { MantineThemeColors } from '@mantine/core'

export const primaryColors: Partial<MantineThemeColors> = {
    primary: [
        '#E0F4FF',
        '#C0EAFF',
        '#A0E0FF',
        '#80D6FF',
        '#59CDFF',
        '#33C3FF',
        '#0F97D0',
        '#077EB5',
        '#03658F',
        '#01486C'
    ],
    gray: [
        '#F2F6F8',
        '#DEE5E9',
        '#C3D0D6',
        '#9FB3BC',
        '#677F89',
        '#465D68',
        '#324E4E',
        '#203237',
        '#1C292F',
        '#111C20'
    ],
    dark: [
        '#A9BFC9',
        '#93ADC8',
        '#627F83',
        '#4A606A',
        '#283A42',
        '#233439',
        '#1C282E',
        '#162026',
        '#0F161A',
        '#0C1214'
    ],
    red: ['#FFEFED', '#FFD3CF', '#FBA6A9', '#FA7272', '#F67378', '#ED4649', '#CC2429', '#A61B20', '#7E1E21', '#5B0505'],
    teal: [
        '#EDF9EB',
        '#DAF2D0',
        '#D8F5A2',
        '#C0EB75',
        '#A9E34B',
        '#8DC102',
        '#5C9E14',
        '#447C07',
        '#1A4000',
        '#123000'
    ],
    orange: [
        '#FFF3EB',
        '#FFE4C8',
        '#FFD3A2',
        '#FFB17A',
        '#FF8E3D',
        '#EB6200',
        '#AC4902',
        '#7D3A00',
        '#4D2000',
        '#331800'
    ],
    yellow: [
        '#FFF9E5',
        '#FFF3C2',
        '#FFEC99',
        '#FFE066',
        '#FCC419',
        '#FAB006',
        '#D19200',
        '#9D5100',
        '#774200',
        '#492500'
    ],
    indigo: [
        '#F2F8FD',
        '#DCE9F9',
        '#BCD4F3',
        '#A994FF',
        '#8373FF',
        '#654DF9',
        '#471DF0',
        '#0F2BA6',
        '#051A85',
        '#13005A'
    ],
    grape: [
        '#F9F0FC',
        '#F3E4FA',
        '#E8C9F6',
        '#E599F7',
        '#DA77F2',
        '#CC5DE8',
        '#AE3EC9',
        '#9C36B5',
        '#862E9C',
        '#702283'
    ],
    pink: [
        '#FFF0F6',
        '#FFDEEB',
        '#FCC2D7',
        '#FAA2C1',
        '#F783AC',
        '#F06595',
        '#E64980',
        '#D6336C',
        '#C2255C',
        '#A61E4D'
    ],
    // Neutral colors as single values (not arrays)
    // Data visualization colors as an array
    'data-viz': [
        '#3866B1',
        '#F8CC2D',
        '#6DBA52',
        '#D7507E',
        '#26A0B0',
        '#9B6EF3',
        '#F76E6E',
        '#5DDC9A',
        '#9C27B0',
        '#FF9800'
    ]
}
